// extracted by mini-css-extract-plugin
export default {"filtersList":"sections-module___filtersList___b15a723a","header":"sections-module___header___abce0564"};